import {Page} from "@/libwyze-shared/types";
import React, {ReactElement, useState} from "react";
import {Box, Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinScreenType, CheckinState, LookupType} from "./CheckinPlayerPreviewFragment";
import {CheckinLargeButton, CheckinLargeTextField} from "@/checkin-shared/Components";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {PAGE_FRAGMENT_HALF_WIDTH, PAGE_FRAGMENT_XSM_WIDTH, PD_MD, PD_XSM} from "@/shared/dimens";
import {Numpad} from "./components/Numpad";

export function EnterPhoneNumberScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
  lookupType: LookupType,
}): ReactElement {
  const [phone, setPhone] = useState("");

  const handleKey = (key: string) => {
    if (key === "BACKSPACE") {
      setPhone(phone.slice(0, -1));
    } else {
      setPhone(phone + key);
    }
  };

  return <StyledBoxColumn style={{width: "100%", height: "100%"}}>
    <StyledBoxRow style={{width: "100%", flex: 1, alignItems: "flex-start", gap: 48}}>
      <StyledBoxColumn style={{flex: 1, alignItems: "flex-start"}}>
        <Typography variant={"h2"} style={{fontWeight: 900}}>
          Enter your phone number.
        </Typography>
        <Typography style={{fontSize: "100%", opacity: 0.5}}>
          We'll match by the number on file.
        </Typography>
        <Box style={{marginTop: PD_MD}}/>
        <StyledBoxColumn style={{gap: PD_XSM, width: "100%"}}>
          <Typography variant="caption" style={{fontWeight: 600, textTransform: "uppercase", opacity: 0.5}}>
            Phone number
          </Typography>
          <CheckinLargeTextField
            autoFocus={true}
            style={{width: "100%"}}
            placeholder="e.g. +1 555 123 4567"
            value={phone}
            onChange={e => setPhone(e.target.value || "")}
          />
        </StyledBoxColumn>
      </StyledBoxColumn>
      <StyledBoxColumn style={{flexShrink: 0, width: PAGE_FRAGMENT_XSM_WIDTH, paddingTop: 48}}>
        <CheckinLargeButton
          endIcon={<ArrowForwardOutlined style={{fontSize: "125%"}}/>}
          disabled={!phone.trim()}
          onClick={() => {
            props.pushScreenType(props.lookupType === LookupType.APPOINTMENT
              ? CheckinScreenType.APPOINTMENT_CONFIRM
              : CheckinScreenType.PROFILE_CONFIRM);
          }}>
          {props.lookupType === LookupType.APPOINTMENT ? "Find my appointment" : "Find my profile"}
        </CheckinLargeButton>
      </StyledBoxColumn>
    </StyledBoxRow>
    <Numpad onKey={handleKey}/>
  </StyledBoxColumn>;
}
